import { render, staticRenderFns } from "./keycloakregister.vue?vue&type=template&id=38e56a75"
import script from "./keycloakregister.vue?vue&type=script&lang=js"
export * from "./keycloakregister.vue?vue&type=script&lang=js"
import style0 from "./keycloakregister.vue?vue&type=style&index=0&id=38e56a75&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports